import { render, staticRenderFns } from "./EditVersionDialog.vue?vue&type=template&id=690ec88f"
import script from "./EditVersionDialog.vue?vue&type=script&lang=js"
export * from "./EditVersionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports